export const alwaysWhiteBackgroundComponents:any = {
    // Due to the specific design some components always has white BG.
    // But users still can change the BG color - but the color is applied to an inner element.

    // NB! if you add new items also consider adding an item here: force_white_bg_if_needed.py
    cta_form: ['08'],
    cta_button: ['27', '28'],
    text: ['01']
};